import React, { useEffect, useState } from 'react'

import Dropdown from '../../components/common/forms/Dropdown/Dropdown.tsx'

const AddFolder = ({
  edited,
  setEdited,
  selectedCalories,
  setSelectedCalories,
  selectedMeals,
  setSelectedMeals,
  saveFolder,
  setAddNewFolder
}: {
  edited: number | null
  setEdited: React.Dispatch<React.SetStateAction<number | null>>
  selectedCalories: string | null
  setSelectedCalories: React.Dispatch<React.SetStateAction<string | null>>
  selectedMeals: string | null
  setSelectedMeals: React.Dispatch<React.SetStateAction<string | null>>
  saveFolder: () => void
  setAddNewFolder: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const optionsMeals = ['3', '4', '5']
  const optionsEnergy = ['1300','1500', '1800', '2100', '2400', '2700']

  const [onStartMeal, setOnStartMeals] = useState<number | undefined>(undefined)
  const [onStartEnergy, setOnStartEnergy] = useState<number | undefined>(
    undefined
  )

  const indexOnStart = (options: string[], value: string) =>
    options.findIndex((option) => option === value)

  useEffect(() => {
    if (edited) {
      setOnStartMeals(indexOnStart(optionsMeals, selectedMeals as string))
      setOnStartEnergy(indexOnStart(optionsEnergy, selectedCalories as string))
    } else {
      setOnStartMeals(undefined)
    }
  }, [edited, selectedMeals, selectedCalories])

  useEffect(() => {
    if(edited) {
      setSelectedCalories(selectedCalories)
      setSelectedMeals(selectedMeals)
    }
  }, [edited])

  return (
    <div className={'flex flex-1 flex-col -mt-2'}>
      <div>
        <Dropdown
          placeholder="Liczba posiłków"
          options={optionsMeals}
          onSelect={setSelectedMeals}
          labelExtractor={(item) => item.toString()}
          className={'p-0'}
          optionOnStart={onStartMeal}
        />
        <Dropdown
          placeholder="Liczba kalorii"
          options={optionsEnergy}
          onSelect={setSelectedCalories}
          labelExtractor={(item) => item.toString()}
          className={'-mt-6'}
          optionOnStart={onStartEnergy}
        />
      </div>
      <div className={'flex flex-row justify-center gap-1'}>
        <button
          className="bg-yellow-300 text-white px-4 py-0 rounded-md hover:bg-yellow-400"
          onClick={(e) => {
            e.stopPropagation()
            setSelectedMeals(null)
            setSelectedCalories(null)
            setAddNewFolder(false)
            setEdited(null)
          }}
        >
          Anuluj
        </button>
        <button
          className="bg-green-500 text-white px-4 py-0 rounded-md hover:bg-green-600"
          onClick={(e) => {
            e.stopPropagation()
            saveFolder()
          }}
        >
          Zapisz
        </button>
      </div>
    </div>
  )
}

export default AddFolder
